export enum TipoErrorEnum {
  ERROR001 = 'autolectura.001',
  ERROR003 = 'autolectura.003',
  ERROR007 = 'autolectura.007',
  ERROR008 = 'autolectura.008',
  ERROR009 = 'autolectura.009',
}
